import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function MirrorPage() {
  const { clientId } = useParams();
  const { enterMirrorMode, token } = useAuth();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const init = async () => {
      if (!token || !clientId) return;
      try {
        const result = await enterMirrorMode(clientId);
        if (result.success) {
          setReady(true);
        } else {
          setError(result.error || 'Erreur connexion miroir');
        }
      } catch {
        setError('Erreur connexion miroir');
      }
    };
    init();
  }, [token, clientId, enterMirrorMode]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <p className="text-red-500">{error}</p>
          <p className="text-sm text-muted-foreground">Fermez cet onglet et réessayez</p>
        </div>
      </div>
    );
  }

  if (ready) {
    return <Navigate to="/client" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary" />
        <p className="text-muted-foreground">Chargement de la vue client...</p>
      </div>
    </div>
  );
}
